import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';

const url = `
url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' %3E%3Cdefs%3E%3ClinearGradient id='a' x1='0' x2='0' y1='0' y2='1'%3E%3Cstop offset='0' stop-color='%23000000'/%3E%3Cstop offset='1' stop-color='%23000000'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cpattern id='b' width='4' height='4' patternUnits='userSpaceOnUse'%3E%3Ccircle fill='%23ffffff' cx='2' cy='2' r='2'/%3E%3C/pattern%3E%3Crect width='100%25' height='100%25' fill='url(%23a)'/%3E%3Crect width='100%25' height='100%25' fill='url(%23b)' fill-opacity='0.1'/%3E%3C/svg%3E");
`;

const useStyles = makeStyles((theme) => ({
  paper: {
    height: '100%',
    padding: theme.spacing(5),
    boxShadow: 'none',
    backgroundColor: 'transparent'
  },
  strip: {
    backgroundColor: '#000000',
    backgroundImage: url,
    backgroundAttachment: 'fixed',
    backgroundSize: 'cover',
    borderTop: '3px dotted white',
    borderBottom: '3px dotted white',
  },
}));


const Strip = () => {
  const classes = useStyles();

  return (
    <>
      <Container
        className={classes.strip}
        maxWidth="false"
      >
        <Container>
          <Paper className={classes.paper}>
            <Typography
              align="center"
              component="h2"
              style={{color: 'white'}}
              variant="h2"
            >
          " Jouons à sauver le monde pour de vrai "
            </Typography>
            <Typography
              align="right"
              component="p"
              style={{color: 'white', marginBottom: 0}}
              variant="body2"
            >
          Henry Médeau - Créateur de SeedOut Fenua
            </Typography>
          </Paper>
        </Container>
      </Container>
    </>
  );
}

export default Strip;
